import { useQuery } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { API } from 'network/api';

type Params = {
  taskId?: string;
};

export type TaskHistory = {
  id: string;
  changesMessage: string;
  revisionDate: string;
  relatedData: RelatedData;
};

type RelatedData = {
  status: string;
  note: string;
  oldValue: string;
  newValue: string;
  taskDescription: string;
  taskSubType: string;
  actorName: string;
  actorEmail: string;
};

const fetchTaskHistory = async (params?: Params) => {
  const response = await API.get('/audit/task_assignment', { params });
  return response;
};

const useTaskHistoryQuery = (params?: Params) => {
  const query = useQuery<AxiosResponse<TaskHistory[], AxiosError>>({
    queryKey: ['task-history', params],
    queryFn: () => fetchTaskHistory(params),
    enabled: !!params?.taskId,
  });

  return query;
};

export default useTaskHistoryQuery;
